// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CovidRequestGuest from '../_raw/service/icon_covid_request_guest.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CovidRequestGuest);
